export const TOPICS = {
  profile:   { name: 'About Me',           color: 0xf4d68c, hex: '#f4d68c', short: 'Me' },
  quant:     { name: 'Quant & Trading',    color: 0xf0a040, hex: '#f0a040', short: 'Quant' },
  ai:        { name: 'AI / ML / NLP',      color: 0xd96bff, hex: '#d96bff', short: 'AI/ML' },
  quantum:   { name: 'Quantum',            color: 0x6ad0ff, hex: '#6ad0ff', short: 'Quantum' },
  cognitive: { name: 'Cognitive Systems',  color: 0x4dd9a8, hex: '#4dd9a8', short: 'Cognitive' },
  cv:        { name: 'Computer Vision',    color: 0xff7a4d, hex: '#ff7a4d', short: 'CV' },
  platform:  { name: 'Platform & Web',     color: 0x7da4f0, hex: '#7da4f0', short: 'Platform' },
  audio:     { name: 'Audio / Speech AI',  color: 0xffd060, hex: '#ffd060', short: 'Audio' },
  viz:       { name: 'Data Visualization', color: 0xff7090, hex: '#ff7090', short: 'Viz' },
  sim:       { name: 'Simulation / OR',    color: 0xa880ff, hex: '#a880ff', short: 'Sim' },
  misc:      { name: 'Additional Work',    color: 0xb0b0b0, hex: '#b0b0b0', short: 'Misc' }
};

export const CATEGORY_ORDER = ['profile', 'quant', 'ai', 'quantum', 'cognitive', 'cv', 'platform', 'audio', 'viz', 'sim', 'misc'];
